// extracted by mini-css-extract-plugin
export default {"page-sidebar":"SideBar_page-sidebar__k8ULd","page-sidebar-content":"SideBar_page-sidebar-content__x-hEt","page-logo":"SideBar_page-logo__0y8Pp"};